import * as yup from 'yup';
import {
	isIcelandicShipmentPhone,
	isShipmentPhoneMissingInternationalPrefix,
	isValidOptionalShipmentPhone,
	validateForeignPostcode,
	validateSsn,
} from '../../../../helpers/formHelpers/formHelpers';

export const getBusinessAccountRegisterShipmentUrl = (lang: string) =>
	lang === 'en'
		? 'https://fyrirtaeki.posturinn.is/en/registerShipment'
		: 'https://fyrirtaeki.posturinn.is/registerShipment';

export const isCompanySender = (values: { senderHasForeignSsn?: boolean; senderSsn?: string }) =>
	!values.senderHasForeignSsn && Number((values.senderSsn || '').substring(0, 1)) > 3;

export const requiresBusinessAccountForCompanySender = (values: {
	senderHasForeignSsn?: boolean;
	senderSsn?: string;
	country?: { requiresBusinessAccountForCompanySender?: boolean; requiresMerchProdId?: boolean };
}) =>
	isCompanySender(values) &&
	(!!values.country?.requiresBusinessAccountForCompanySender || !!values.country?.requiresMerchProdId);

const shipmentPhoneValidationMessage = (value?: string) =>
	isIcelandicShipmentPhone(value)
		? 'step-info.mobile-format'
		: isShipmentPhoneMissingInternationalPrefix(value)
		? 'step-info.phone-international-prefix'
		: 'step-info.phone-format';

const validateOptionalShipmentPhone = function (value?: string) {
	return isValidOptionalShipmentPhone(value) || this.createError({ message: shipmentPhoneValidationMessage(value) });
};

export const setOutOfCountrySchema = (schema: any, country: string) => {
	const updatedSchema = schema.shape({
		receiverPostCode: yup.object().nullable(),
		receiverForeignPostCode: yup
			.string()
			.required('step-info.field-required')
			.test('is-valid-ssn', 'step-info.zip-incorrect', function (value) {
				return validateForeignPostcode(value, country, this.createError, 'receiverForeignPostCode');
			}),
		receiverForeignShipTo: yup.string().max(35, 'step-info.max'),
		receiverForeignAddressExtended: yup.string().max(35, 'step-info.max'),
		receiverForeignPlace: yup.string().max(35, 'step-info.max').required('step-info.field-required'),
		receiverPhone: yup
			.string()
			.test('is-valid-shipment-phone', 'step-info.phone-format', validateOptionalShipmentPhone),
		receiverEmail: yup
			.string()
			.email('step-info.email-format')
			.when('receiverPhone', {
				is: phone => !(phone && phone.trim().length > 0),
				then: yup.string().required('step-info.required-email-or-phone').email('step-info.email-format'),
			}),
	});

	return updatedSchema;
};

export const setPostboxSchema = (schema: any) => {
	const updatedSchema = schema.shape({
		receiverPhone: yup
			.string()
			.min(7, 'step-info.phone-min')
			.max(7, 'step-info.phone-sender-max')
			.matches(/^[6-8][0-9]*$/, 'step-info.mobile-format')
			.required('step-info.phone-required'),
	});

	return updatedSchema;
};

export const setReceiverPaysSchema = (schema: any) => {
	const updatedSchema = schema.shape({
		senderSsn: yup
			.string()
			.required('step-info.field-required')
			.min(10, 'step-info.ssn-min')
			.test('is-valid-ssn', 'step-info.ssn-valid', validateSsn),
	});

	return updatedSchema;
};
